import { OnboardingLayout } from '@/components/OnboardingLayout'
import { createFileRoute } from '@tanstack/react-router'
import { CheckCircle2Icon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

const searchSchema = z.object({
  reason: z
    .enum(['login_link_sent', 'join_confirmation_sent', 'account_created_login_link_sent'])
    .catch('login_link_sent'),
})

const COPY = {
  login_link_sent: {
    title: 'onboarding.success.existingTitle',
    subtitle: 'onboarding.success.existingSubtitle',
  },
  join_confirmation_sent: {
    title: 'returningDriver.joinPending.title',
    subtitle: 'returningDriver.joinPending.subtitle',
  },
  // Auto-login failed on a genuinely new account: "We found your account" would be
  // a lie, so this keeps the created-the-account wording with the email fallback.
  account_created_login_link_sent: {
    title: 'onboarding.success.title',
    subtitle: 'onboarding.success.subtitle',
  },
} as const

export const Route = createFileRoute('/onboard/$flow/$token/success')({
  validateSearch: searchSchema,
  component: SuccessPage,
})

function SuccessPage() {
  const { t } = useTranslation('ui')
  const { reason } = Route.useSearch()
  const copy = COPY[reason]

  return (
    <OnboardingLayout>
      <div className="flex flex-col items-center gap-6 py-12 text-center">
        <div className="rounded-full bg-primary/10 p-4">
          <CheckCircle2Icon className="size-10 text-primary" />
        </div>
        <div>
          <h1 className="text-xl font-bold">{t(copy.title)}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{t(copy.subtitle)}</p>
        </div>
      </div>
    </OnboardingLayout>
  )
}
